<template>
    <div>
        <ErrorAlert :message="message" :error="error" />
        <StageComplete v-if="stageComplete" :message="message" :error="error" />
        <div v-else>
            <div class="card card-body border-0">
                <h6 class="font-weight-bold mb-4">Bank Account Details</h6>
                <div id="bankDetailsAccordion">
                    <!-- USD Account Details (Mandatory) -->
                    <div class="card">
                        <div class="card-header" id="usdHeading">
                            <h6 class="mb-0">
                                <button
                                    class="btn btn-link collapsed"
                                    type="button"
                                    data-toggle="collapse"
                                    data-target="#usdAccount"
                                    aria-expanded="true"
                                    aria-controls="usdAccount"
                                    :disabled="usdSubmitted"
                                >
                                    USD Account Details
                                </button>
                            </h6>
                        </div>
                        <div
                            id="usdAccount"
                            class="collapse show"
                            aria-labelledby="usdHeading"
                            data-parent="#bankDetailsAccordion"
                        >
                            <div class="card-body">
                                <div class="form-group">
                                    <label>Bank Name</label>
                                    <input
                                        type="text"
                                        v-model="bankForm.usd_bank_name"
                                        class="form-control"
                                        placeholder="Enter bank name"
                                        list="usdBanks"
                                        :disabled="usdSubmitted"
                                        :readonly="usdSubmitted"
                                    />
                                    <datalist id="usdBanks">
                                        <option v-for="bank in banks" :key="bank" :value="bank" />
                                    </datalist>
                                    <div v-text="bankForm.errors.get('usd_bank_name')" class="text-danger font-12"></div>
                                </div>
                                <div class="form-group">
                                    <label>Account Name</label>
                                    <input
                                        type="text"
                                        v-model="bankForm.usd_account_name"
                                        class="form-control"
                                        placeholder="Enter account name"
                                        :disabled="usdSubmitted"
                                        :readonly="usdSubmitted"
                                    />
                                    <div v-text="bankForm.errors.get('usd_account_name')" class="text-danger font-12"></div>
                                </div>
                                <div class="form-group">
                                    <label>Account Number</label>
                                    <input
                                        type="text"
                                        v-model="bankForm.usd_account_number"
                                        class="form-control"
                                        placeholder="Enter account number"
                                        :disabled="usdSubmitted"
                                        :readonly="usdSubmitted"
                                    />
                                    <div v-text="bankForm.errors.get('usd_account_number')" class="text-danger font-12"></div>
                                </div>
                                <div class="form-group">
                                    <label>Branch</label>
                                    <input
                                        type="text"
                                        v-model="bankForm.usd_branch"
                                        class="form-control"
                                        placeholder="Enter branch name"
                                        :disabled="usdSubmitted"
                                        :readonly="usdSubmitted"
                                    />
                                    <div v-text="bankForm.errors.get('usd_branch')" class="text-danger font-12"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- ZWG Account Details (Optional) -->
                    <div class="card">
                        <div class="card-header" id="zwgHeading">
                            <h6 class="mb-0">
                                <button
                                    class="btn btn-link"
                                    type="button"
                                    data-toggle="collapse"
                                    data-target="#zwgAccount"
                                    aria-expanded="false"
                                    aria-controls="zwgAccount"
                                >
                                    ZWG Account Details (Optional)
                                </button>
                            </h6>
                        </div>
                        <div
                            id="zwgAccount"
                            class="collapse"
                            aria-labelledby="zwgHeading"
                            data-parent="#bankDetailsAccordion"
                        >
                            <div class="card-body">
                                <div class="form-group">
                                    <label>Bank Name</label>
                                    <input
                                        type="text"
                                        v-model="bankForm.zwg_bank_name"
                                        class="form-control"
                                        placeholder="Enter bank name"
                                        list="zwgBanks"
                                        :disabled="zwgSubmitted"
                                    />
                                    <datalist id="zwgBanks">
                                        <option v-for="bank in banks" :key="bank" :value="bank" />
                                    </datalist>
                                    <div v-text="bankForm.errors.get('zwg_bank_name')" class="text-danger font-12"></div>
                                </div>
                                <div class="form-group">
                                    <label>Account Name</label>
                                    <input
                                        type="text"
                                        v-model="bankForm.zwg_account_name"
                                        class="form-control"
                                        placeholder="Enter account name"
                                        :disabled="zwgSubmitted"
                                    />
                                    <div v-text="bankForm.errors.get('zwg_account_name')" class="text-danger font-12"></div>
                                </div>
                                <div class="form-group">
                                    <label>Account Number</label>
                                    <input
                                        type="text"
                                        v-model="bankForm.zwg_account_number"
                                        class="form-control"
                                        placeholder="Enter account number"
                                        :disabled="zwgSubmitted"
                                    />
                                    <div v-text="bankForm.errors.get('zwg_account_number')" class="text-danger font-12"></div>
                                </div>
                                <div class="form-group">
                                    <label>Branch</label>
                                    <input
                                        type="text"
                                        v-model="bankForm.zwg_branch"
                                        class="form-control"
                                        placeholder="Enter branch name"
                                        :disabled="zwgSubmitted"
                                    />
                                    <div v-text="bankForm.errors.get('zwg_branch')" class="text-danger font-12"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Submit Button (only shown if USD details are not yet submitted) -->
            <div class="d-flex justify-content-between my-4" v-if="!usdSubmitted">
                <button
                    class="btn btn-primary btn-block"
                    :class="{ 'btn-loading': loading }"
                    @click="submitBankDetails"
                >
                    SUBMIT
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Form from "../../../core/forms/form.js";
import StageComplete from "../components/StageComplete.vue";
import ErrorAlert from "../components/ErrorAlert.vue";
import axios from "axios";

export default {
    name: "BankAccounts",
    components: {
        ErrorAlert,
        StageComplete,
    },
    props: ["stage", "message"],
    data() {
        return {
            banks: [
                "Agribank",
                "BancABC",
                "CABS",
                "CBZ Bank",
                "Ecobank Zimbabwe",
                "FBC Bank",
                "First Capital Bank",
                "IDBZ",
                "Metbank",
                "National Building Society",
                "Nedbank Zimbabwe",
                "NMB Bank",
                "POSB",
                "Stanbic Bank",
                "Standard Chartered",
                "Steward Bank",
                "ZB Bank",
            ],
            bankForm: new Form({
                zwg_bank_name: "",
                zwg_account_name: "",
                zwg_account_number: "",
                zwg_branch: "",
                usd_bank_name: "",
                usd_account_name: "",
                usd_account_number: "",
                usd_branch: "",
            }, {
                rules: {
                    usd_bank_name: 'required',
                    usd_account_name: 'required',
                    usd_account_number: 'required',
                    usd_branch: 'required',
                }
            }),
            stageComplete: false,
            message: "",
            error: false,
            loading: false,
            usdSaved: false,
            zwgSaved: false,
        };
    },
    computed: {
        usdSubmitted() {
            return this.usdSaved;
        },
        zwgSubmitted() {
            return this.zwgSaved;
        },
    },
    methods: {
        async submitBankDetails() {
            this.loading = true;
            this.error = false;
            this.message = "";

            // Get trimmed values for USD fields.
            const usd_bank = this.bankForm.usd_bank_name.trim();
            const usd_acc_name = this.bankForm.usd_account_name.trim();
            const usd_acc_num = this.bankForm.usd_account_number.trim();
            const usd_branch = this.bankForm.usd_branch.trim();

            // Validate that mandatory USD fields are provided.
            if (!usd_bank || !usd_acc_name || !usd_acc_num || !usd_branch) {
                this.error = true;
                this.message = "Please complete all USD account details.";
                this.loading = false;
                return;
            }

            // Get trimmed values for ZWG fields.
            const zwg_bank = this.bankForm.zwg_bank_name.trim();
            const zwg_acc_name = this.bankForm.zwg_account_name.trim();
            const zwg_acc_num = this.bankForm.zwg_account_number.trim();
            const zwg_branch = this.bankForm.zwg_branch.trim();

            // Check if any ZWG field is filled.
            const anyZwgsFilled = zwg_bank || zwg_acc_name || zwg_acc_num || zwg_branch;
            // If any ZWG field is filled, ensure all are provided.
            if (anyZwgsFilled) {
                if (!(zwg_bank && zwg_acc_name && zwg_acc_num && zwg_branch)) {
                    this.error = true;
                    this.message = "Please complete all ZWG account details or leave them all blank.";
                    this.loading = false;
                    return;
                }
            }

            // Build payload. Always include USD fields.
            let payload = {
                usd_bank_name: usd_bank,
                usd_account_name: usd_acc_name,
                usd_account_number: usd_acc_num,
                usd_branch: usd_branch,
                // For ZWG fields, send default values if user left them blank.
                zwg_bank_name: anyZwgsFilled ? zwg_bank : "N/A",
                zwg_account_name: anyZwgsFilled ? zwg_acc_name : "N/A",
                // For account numbers, if the column is integer type, default to "0".
                zwg_account_number: anyZwgsFilled ? zwg_acc_num : "0",
                zwg_branch: anyZwgsFilled ? zwg_branch : "N/A"
            };

            // Debug: Log the payload so you can inspect it in the browser console.
            console.log("Payload for bank details submission:", payload);

            try {
                const response = await axios.post("/business/event-onboarding/bank-details", payload);
                this.stageComplete = true;
                this.message = response.data.message;
                this.usdSaved = true;
                // Re-fetch saved details after successful submission.
                this.loadSavedDetails();
            } catch (err) {
                this.error = true;
                this.message = err.response?.data?.message || "An error occurred while submitting bank details. Please try again.";
            } finally {
                this.loading = false;
            }
        },


        loadSavedDetails() {
            axios.get("/business/event-onboarding/bank-details")
                .then((response) => {
                    const data = response.data.data ? response.data.data : response.data;

                    // USD details
                    if (data?.usd_bank_name?.trim()) {
                        this.bankForm.usd_bank_name = data.usd_bank_name;
                        this.bankForm.usd_account_name = data.usd_account_name;
                        this.bankForm.usd_account_number = data.usd_account_number;
                        this.bankForm.usd_branch = data.usd_branch;
                        this.usdSaved = true;
                    }

                    // ZWG details
                    if (data?.zwg_bank_name?.trim()) {
                        this.bankForm.zwg_bank_name = data.zwg_bank_name;
                        this.bankForm.zwg_account_name = data.zwg_account_name;
                        this.bankForm.zwg_account_number = data.zwg_account_number;
                        this.bankForm.zwg_branch = data.zwg_branch;
                        this.zwgSaved = true;
                    }
                })
                .catch((error) => {
                    console.error("Error loading saved bank details:", error);
                });
        },
    },
    mounted() {
        this.loadSavedDetails();
    }
};
</script>

<style scoped>
input[disabled], input[readonly] {
    background-color: #f8f9fa;
    cursor: not-allowed;
    border: 1px solid #e9ecef;
    color: #495057;
}

.btn-link[disabled] {
    color: #6c757d;
    pointer-events: none;
    text-decoration: none;
}
</style>
